import { render, staticRenderFns } from "./_NavigationTabs.vue?vue&type=template&id=9d4e4c32&scoped=true&"
import script from "./_NavigationTabs.vue?vue&type=script&lang=ts&"
export * from "./_NavigationTabs.vue?vue&type=script&lang=ts&"
import style0 from "./_NavigationTabs.vue?vue&type=style&index=0&id=9d4e4c32&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d4e4c32",
  null
  
)

export default component.exports